import { IComponentOptions } from "angular";
import { ProcessDetailViewController } from "./controller";

export const vsName = "processDetailComponent";

export const processDetailComponentOptions: IComponentOptions = {
  controller: ProcessDetailViewController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    tree: "=",
    processInformation: "<",
    processGroup: "<",
  },
  transclude: {
    infoHeader: "infoHeader",
  },
};
